<div class="row page-header">
    <div class="col-12">
        <h1>Heavy Bid Data <small>View estimate and HCSS activity data</small></h1>
    </div>
</div>
@if (!isInitialLoading) {
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="onActiveTabChanged($event)">
        <!-- <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Estimates</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="estimateGrid"></action-toolbar-count>
                                    <action-toolbar-search name="search" [(ngModel)]="estimateGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="estimateGridFlex" [name]="'Estimates'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    #estimateGridFlex
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="estimateGrid.initialize(estimateGridFlex)"
                                    (destroy)="estimateGrid.destroy()"
                                    [itemsSource]="estimateGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="300"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'dateCreated'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Total Cost'"
                                        [binding]="'estimateTotalCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Actual Bid Markup'"
                                        [binding]="'actualBidMarkup'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Actual Markup Takeoff'"
                                        [binding]="'actualMarkupTakeoff'"
                                        [width]="170"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Addon Bond Total'"
                                        [binding]="'addonBondTotal'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Addon Cost'"
                                        [binding]="'addonCost'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bond Total'"
                                        [binding]="'bondTotal'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Addon Markup'"
                                        [binding]="'addonMarkup'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid Date'"
                                        [binding]="'bidDate'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid Total'"
                                        [binding]="'bidTotal'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Overhead %'"
                                        [binding]="'overheadPercent'"
                                        [width]="120"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="estimateGridFlex"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>HCSS Activities</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="hcssActivityGrid"></action-toolbar-count>
                                    <action-toolbar-search name="search" [(ngModel)]="hcssActivityGrid.filter"></action-toolbar-search>
                                    <grid-export [grid]="hcssActivityGridFlex" [name]="'HCSS Activities'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    #hcssActivityGridFlex
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="hcssActivityGrid.initialize(hcssActivityGridFlex)"
                                    (destroy)="hcssActivityGrid.destroy()"
                                    [itemsSource]="hcssActivityGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Code'"
                                        [binding]="'estimateCode'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Name'"
                                        [binding]="'estimateName'"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Activity Code'"
                                        [binding]="'activityCode'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Activity Description'"
                                        [binding]="'activityDescription'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'dateCreated'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Man Hours'"
                                        [binding]="'manHours'"
                                        [width]="100"
                                        [format]="'N2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Direct Total Cost'"
                                        [binding]="'directTotalCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Labor Cost'"
                                        [binding]="'laborCost'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'Permanent Material Cost'"
                                        [binding]="'permanentMaterialCost'"
                                        [width]="180"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'Construction Material Cost'"
                                        [binding]="'constructionMaterialCost'"
                                        [width]="200"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Equipment Cost'"
                                        [binding]="'equipmentCost'"
                                        [width]="130"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>

                                    <wj-flex-grid-column
                                        [header]="'Subcontract Cost'"
                                        [binding]="'subcontractCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="hcssActivityGridFlex"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li> -->
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Estimates (API)</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="apiEstimateGrid"></action-toolbar-count>
                                    <action-toolbar-search
                                        name="search-api-est"
                                        [(ngModel)]="apiEstimateGrid.filter"
                                    ></action-toolbar-search>
                                    <grid-export [grid]="apiEstimateGridFlex" [name]="'Estimates (API)'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    #apiEstimateGridFlex
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="apiEstimateGrid.initialize(apiEstimateGridFlex)"
                                    (destroy)="apiEstimateGrid.destroy()"
                                    [itemsSource]="apiEstimateGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Code'" [binding]="'code'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="300"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'dateCreated'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Total Cost'"
                                        [binding]="'estimateTotalCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Actual Bid Markup'"
                                        [binding]="'actualBidMarkup'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Actual Markup Takeoff'"
                                        [binding]="'actualMarkupTakeoff'"
                                        [width]="170"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <!-- <wj-flex-grid-column
                                        [header]="'Addon Bond Total'"
                                        [binding]="'addonBondTotal'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column> -->
                                    <wj-flex-grid-column
                                        [header]="'Addon Cost'"
                                        [binding]="'addonCost'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bond Total'"
                                        [binding]="'bondTotal'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Addon Markup'"
                                        [binding]="'addonMarkup'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid Date'"
                                        [binding]="'bidDate'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Bid Total'"
                                        [binding]="'bidTotal'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Overhead %'"
                                        [binding]="'overheadPercent'"
                                        [width]="120"
                                        [format]="'P2'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="apiEstimateGridFlex"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false">
            <a ngbNavLink>HCSS Activities (API)</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="apiHcssActivityGrid"></action-toolbar-count>
                                    <action-toolbar-search
                                        name="search-api-act"
                                        [(ngModel)]="apiHcssActivityGrid.filter"
                                    ></action-toolbar-search>
                                    <grid-export [grid]="apiHcssActivityGridFlex" [name]="'HCSS Activities (API)'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    #apiHcssActivityGridFlex
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="apiHcssActivityGrid.initialize(apiHcssActivityGridFlex)"
                                    (destroy)="apiHcssActivityGrid.destroy()"
                                    [itemsSource]="apiHcssActivityGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Code'"
                                        [binding]="'estimateCode'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Estimate Name'"
                                        [binding]="'estimateName'"
                                        [width]="300"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Activity Code'"
                                        [binding]="'activityCode'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Activity Description'"
                                        [binding]="'activityDescription'"
                                        [width]="250"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Non-Add'" [binding]="'nonAdditive'" [width]="90"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Save Non-Add'"
                                        [binding]="'saveNonAdditive'"
                                        [width]="110"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Date Created'"
                                        [binding]="'dateCreated'"
                                        [width]="130"
                                        [format]="'d'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Man Hours'"
                                        [binding]="'manHours'"
                                        [width]="100"
                                        [format]="'N2'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Direct Total Cost'"
                                        [binding]="'directTotalCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Labor Cost'"
                                        [binding]="'laborCost'"
                                        [width]="120"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Permanent Material Cost'"
                                        [binding]="'permanentMaterialCost'"
                                        [width]="180"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Construction Material Cost'"
                                        [binding]="'constructionMaterialCost'"
                                        [width]="200"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Equipment Cost'"
                                        [binding]="'equipmentCost'"
                                        [width]="130"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Subcontract Cost'"
                                        [binding]="'subcontractCost'"
                                        [width]="150"
                                        [format]="'C0'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="apiHcssActivityGridFlex"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
}
